export default {
  portal: {
    title: "Portal de Proveedores",
    welcomeMessage: "Gestione sus reservas y vea los próximos horarios",
    noBookings: "No se han encontrado reservas",
    noBookingsSub: "No hay reservas que mostrar para el periodo seleccionado.",
    caseNumber: "Caso #",
    client: "Cliente",
    firstName: "Nombre",
    lastName: "Apellido",
    clientPhone: "Teléfono",
    clientEmail: "Email",
    clientAddress: "Dirección del Cliente",
    clientObservations: "Observaciones del Cliente",
    clientDetails: "Detalles del Cliente",
    checkIn: "Entrada",
    checkOut: "Salida",
    nights: "noches",
    supplierName: "Proveedor",
    location: "Ubicación",
    roomType: "Tipo de Habitación",
    dates: "Fechas",
    resource: "Recurso",
    details: "Detalles",
    price: "Precio",
    total: "Total",
    status: "Estado",
    bookingStatus: "Reserva",
    paymentStatus: "Pago",
    invoiceStatus: "Factura",
    quantity: "Cant",
    pax: "Pax",
    upcoming: "Próximas",
    past: "Pasadas",
    searchLabel: "Cliente / Nombre / Número del Caso",
    searchPlaceholder: "Buscar por cliente, nombre o número del caso...",
    clearFilters: "Limpiar filtros",
    clientTooltip: "Los detalles del cliente serán visibles 48 horas antes de la entrada",
    priceTooltip: "Haga clic en el icono del lápiz para introducir su precio",
    editPriceTooltip: "Editar su precio",
    caseNumberTooltip: "Número de referencia de reserva interna"
  },
  sendPortalLink: "Enviar enlace de acceso al portal",
  sendPortalLinkConfirmTitle: "Enviar enlace al portal",
  sendPortalLinkConfirmText: "¿Está seguro de que desea enviar el enlace de acceso al portal a \"{supplier}\"?",
  sendPortalLinkSuccess: "Correo electrónico enviado correctamente",
  sendPortalLinkError: "No se pudo enviar el correo electrónico",
  portalLoginLinkSection: "Acceso al Portal de Proveedores",
  portalLoginLinkDescription: "Envíe un correo electrónico al proveedor con el enlace de acceso a nuestro Portal de Proveedores.",
  suppliers: "Proveedores",
  noSuppliers: "No hay proveedores",
  createNewSupplier: "Crear nuevo proveedor",
  archivedSuppliers: "Proveedores archivados",
  activeSuppliers: "Proveedores activos",
  basicInformation: "Información básica",
  supplierDetails: "Detalles del proveedor",
  email: "Email de notificación",
  archiveText: "Puedes archivar un proveedor, si lo haces el proveedor no aparecerá en las búsquedas de la aplicación. Podrás verlo en la lista de proveedores si filtras por 'archivado'. Una vez veas los detalles de un proveedor archivado, puedes eliminarlo definitivamente o desarchivarlo.",
  media: "Multimedia",
  noMedia: "No hay multimedia asociada",
  archivedText: "Este proveedor está archivado, si lo deseas puedes desarchivarlo haciendo clic en el botón 'Restaurar'.",
  archiveSupplierTitle: "Archivar proveedor",
  archiveSupplierText: "¿Seguro que quieres archivar el proveedor '{supplier}'? Si lo archivas, no aparecerá en las búsquedas.",
  deleteText: "Este proveedor está archivado, si quieres eliminarlo permanentemente haz clic en el botón 'Eliminar'. Ten en cuenta que si lo eliminas, este proveedor dejará de existir y no podrá ser recuperado.",
  deleteSupplierTitle: "Eliminar proveedor",
  deleteSupplierText: "¿Seguro que quieres eliminar el proveedor '{supplier}'? Si lo eliminas, no podrás recuperarlo.",
  restoreSupplierTitle: "Recuperar proveedor",
  restoreSupplierText: "¿Seguro que quieres recuperar el proveedor '{supplier}'? Si lo recuperas, dejará de estar archivado y aparecerá en las búsquedas de la aplicación.",
  supplierStatus: "Estado del proveedor",
  products: "Productos",
  noProducts: "No hay productos asociados",
  showHiddenProducts: "Mostrar productos ocultos",
  hideHiddenProducts: "Ocultar productos ocultos",
  noHiddenProducts: "No hay productos ocultos",
  editProductsBelongSupplierText: "Editar productos pertenecientes al proveedor",
  contacts: "Contactos",
  noContacts: "No hay contactos asociados",
  editContactsBelongSupplierText: "Editar contactos pertenecientes al proveedor",
  addContacts: "Añadir contactos",
  removeContactTitle: "Eliminar contacto del proveedor",
  removeContactText: "¿Seguro que quieres eliminar '{contact}' como contacto para el proveedor '{supplier}'?",
  supplierSearch: "Búsqueda de proveedores",
  removeMediaTitle: "Eliminar multimedia",
  removeMediaText: "¿Seguro que quieres eliminar el archivo? Si lo eliminas, no podrás recuperarlo.",
  exportErrorToast: "No tienes permiso para exportar reservas. Por favor contacta a tu administrador.",
  rates: "Tarifas",
  rate: {
    description: "Añade aquí las formas en que se puede vender este producto.",
    descriptionOnlyView: "Las formas en que se puede vender este producto",
    create: "Crear tarifa",
    update: "Actualizar tarifa",
    delete: "Eliminar tarifa",
    duplicate: "Duplicar tarifa",
    duplicateBlock: "Duplicar",
    basicInformation: "Información básica",
    typeNoOptions: "No hay tipos disponibles",
    categoryNoOptions: "No hay categorías disponibles",
    product: "Producto",
    type: "Tipo",
    category: "Categoría",
    initDate: "Fecha de inicio",
    endDate: "Fecha final",
    price: "Precio",
    removeTitle: "Eliminar tarifa",
    singleRate: "Duplicarás la siguiente tarifa",
    blockRate: "Duplicarás el siguiente bloque",
    removeText: "¿Seguro que quieres borrar la tarifa del producto '{product}'? Si la borras, no podrás recuperarla."
  },
  resource: {
    createNew: "Crear nuevo producto",
    basicInformation: "Información básica",
    title: "Detalles del producto",
    archiveTitle: "Archivar producto del proveedor",
    archiveText: "¿Seguro que quieres archivar el producto '{resource}' de '{supplier}'? Si lo archivas, no aparecerá en las búsquedas.",
    media: "Multimedia",
    noMedia: "No hay multimedia asociada",
    removeMediaTitle: "Eliminar multimedia",
    removeMediaText: "¿Seguro que quieres eliminar el archivo? Si lo eliminas, no podrás recuperarlo."
  }
};
